import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { LandingPage } from '../../pages/landingpage'
import { authQueryFn, getTabs } from '../../services/auth'

export const Route = createFileRoute('/$clientid/_app')({
    beforeLoad: async ({ params, context }) => {
        const { queryClient } = context
        const data = await queryClient.fetchQuery({
            queryKey: ['authKeys', params.clientid],
            queryFn: () => authQueryFn(true),
        })

        // We will add authentication here later
        // Route users to default broadlume page in case of missing client id.

        if (!params?.clientid) {
            throw redirect({
                to: '/404',
            })
        }

        await queryClient.setQueryData(['clientId'], params.clientid)

        if (!data.accessToken || !data.idToken || !data.refreshToken) {
            throw redirect({
                to: '/$clientid/login',
                params,
            })
        }

        // Route params are decoded by TanStack Router, while location.pathname
        // is URL-encoded. Compare decoded values only; comparing those two forms
        // causes a redirect loop for client IDs with spaces or other special chars.
        if (
            params.clientid.toLowerCase() !==
            data.userDetails.Module.toLowerCase()
        ) {
            localStorage.clear()
            throw redirect({
                to: '/$clientid/login',
                params,
            })
        }

        const tabList = getTabs({
            userDetails: data.userDetails,
        })
        if (
            tabList.length &&
            !tabList.find((item) => item.id === location.pathname.split('/')[2])
        ) {
            throw redirect({
                to: '/$clientid/401',
                params,
            })
        }
    },
    component: () => (
        <LandingPage>
            <Outlet />
        </LandingPage>
    ),
})
